export const bereiche = [
  { id: 'tagebuch', titel: 'Tagebuch', symbol: '📖' },
  { id: 'personen', titel: 'Personen', symbol: '👥' },
  { id: 'termine', titel: 'Termine', symbol: '📅' },
  { id: 'fragen', titel: 'Fragen', symbol: '💬' },
] as const

export type BereichId = (typeof bereiche)[number]['id']

/** Seiten ausserhalb der unteren Leiste */
const seiten = ['konto', 'verwaltung', 'freunde', 'geteilt'] as const
export type SeiteId = BereichId | (typeof seiten)[number]

export interface Ort {
  bereich: SeiteId
  /** Weitere Pfadteile, z. B. ['12'] fuer #personen/12 oder ['tag', 'garten'] fuer #tagebuch/tag/garten */
  pfad: string[]
}

export function ortAusHash(hash: string): Ort {
  const [kopf, ...pfad] = hash.replace(/^#/, '').split('/').map((t) => {
    try {
      return decodeURIComponent(t)
    } catch {
      return t
    }
  })
  // #aufnehmen: Kurzlink zum Tagebuch, der die Aufnahme sofort startet (Sprachassistent, Widget, Verknüpfung, NFC)
  if (kopf === 'aufnehmen') return { bereich: 'tagebuch', pfad: ['aufnehmen'] }
  const bereich: SeiteId | undefined = bereiche.find((b) => b.id === kopf)?.id ?? seiten.find((s) => s === kopf)
  return bereich ? { bereich, pfad: pfad.filter(Boolean) } : { bereich: 'tagebuch', pfad: [] }
}

export const link = {
  person: (id: number) => `#personen/${id}`,
  ueberMich: '#personen/ich',
  tag: (name: string) => `#tagebuch/tag/${encodeURIComponent(name)}`,
  notizenVon: (personId: number) => `#tagebuch/person/${personId}`,
  notiz: (id: number) => `#tagebuch/notiz/${id}`,
  archiv: '#tagebuch/archiv',
  aufnehmen: '#aufnehmen',
  geteilt: (id: number) => `#geteilt/${id}`,
}

export type MailLinkArt = 'einladung' | 'reset' | 'email'
export interface MailLinkDaten {
  art: MailLinkArt
  token: string
}

/**
 * Links aus Mails: #einladung=…, #reset=…, #email=… Das Token steht hinter "#", damit es nie an einen Server
 * (und in dessen Log) geht.
 */
export function mailLinkAusHash(hash: string): MailLinkDaten | null {
  const m = /^#?(einladung|reset|email)=([A-Za-z0-9_-]+)$/.exec(hash)
  return m ? { art: m[1] as MailLinkArt, token: m[2] } : null
}
